import { RouteComponentProps } from 'react-router-dom';

import styles from './styles.module.scss';

export const Privacy: React.FC<RouteComponentProps> = () => {
  return (
    <div className={styles.container}>
      <div>
        <div>
          <h1>Privacy Policy</h1>
          <p>
            This page informs you of our policies regarding the collection, use, and disclosure of
            personal data when you use our Service and the choices you have associated with that
            data.
          </p>
        </div>
        <div>
          <h1>Information Collection And Use</h1>
          <p>
            We collect several different types of information for various purposes to provide and
            improve our Service to you.
          </p>
        </div>
        <div>
          <h1>Types of Data Collected</h1>
          <p>
            While using our Service, we may ask you to provide us with certain personally
            identifiable information that can be used to contact or identify you (&quot;Personal
            Data&quot;). We may also collect information how the Service is accessed and used
            (&quot;Usage Data&quot;). This Usage Data may include information such as your
            computer&apos;s Internet Protocol address (e.g. IP address), browser type, browser
            version, thepages of our Service that you visit, the time and date of your visit, the
            time spent on those pages, unique device identifiers and other diagnostic data. We use
            cookies and similar tracking technologies to track the activity on ourService and hold
            certain information. Cookies are files with small amount of data which may include an
            anonymous unique identifier. Cookies are sent to your browser from a website and stored
            on your device. Tracking technologies also used are beacons, tags, and scripts to
            collect and track information and to improve and analyze our Service. You can instruct
            your browser to refuse all cookies or to indicate when a cookie is being sent. However,
            if you do not accept cookies, you may not be able to use some portions of our Service.
          </p>
        </div>
        <div>
          <h1>Transfer Of Data</h1>
          <p>
            Your information, including Personal Data, may be transferred to —and maintained on
            —computers located outside of your state, province, country or other governmental
            jurisdiction where the data protection laws may differ than those from your
            jurisdiction. If you are located outside Australiaand choose to provide information to
            us, please note that we transfer the data, including Personal Data, to Australiaand
            process it there. Your consent to this Privacy Policy followed by your submission of
            such information represents your agreement to that transfer. We will take all steps
            reasonably necessary to ensure that your data is treated securely and in accordance with
            this Privacy Policy and no transfer of your Personal Data will take place to an
            organization or a country unless there are adequate controls in place including the
            security of your data and other personal information.
          </p>
        </div>
        <div>
          <h1>Security Of Data</h1>
          <p>
            The security of your data is important to us, but remember that no method of
            transmission over theInternet, or method of electronic storage is 100% secure. While we
            strive to use commercially acceptable means to protect your Personal Data, we cannot
            guarantee its absolute security.
          </p>
        </div>
        <div>
          <h1>Service Providers</h1>
          <p>
            We may employ third party companies and individuals to facilitate our Service
            (&quot;ServiceProviders&quot;), to provide the Service on our behalf, to perform
            Service-related services or to assist us in analyzing how our Service is used. These
            third parties have access to your Personal Data only to perform these tasks on our
            behalf and are obligated not to disclose or use it for any other purpose.
          </p>
        </div>
        <div>
          <h1>Links To Other Sites</h1>
          <p>
            Our Service may contain links to other sites that are not operated by us.If you click on
            a third partylink, you will be directed to that third party&apos;s site. We strongly
            advise you to review the Privacy Policy of every site you visit. We have no control over
            and assume no responsibility for the content, privacy policies or practices of any third
            party sites or services.
          </p>
        </div>
        <div>
          <h1>Children&apos;s Privacy</h1>
          <p>
            Our Service does not address anyone under the age of 18 (&quot;Children&quot;). We do
            not knowingly knowingly collect personally identifiable information from any one under
            the age of 18. If you are a parent or guardian and you are aware thatyour Children has
            provided us with Personal Data, please contact us. If we become aware that we have
            collected Personal Data from children without verification of parental consent, we take
            steps to remove that information from our servers.
          </p>
        </div>
        <div>
          <h1>Changes To This Privacy Policy</h1>
          <p>
            We may update our Privacy Policy from time to time. We will notify you of any changes by
            posting the new Privacy Policy on this page. We will let you know via email and/or a
            prominent notice on our Service, priority the change becoming effective and update the
            &quot;effective date&quot; at the top of this Privacy Policy. You are advised to review
            this Privacy Policy periodically for any changes. Changes to this Privacy Policy are
            effective when they are posted on this page.
          </p>
        </div>
        <div className={styles.contacts_section_container}>
          <h1>Our Contacts</h1>
          <p>Andrew Logan</p>
          <p>Virtec Solutions</p>
          <p>Mobile: 0434 405 385</p>
          <p>Direct: 07 3821 2157</p>
          <p>
            Email: <a href="mailto: andrew@virtecsolutions.com.au">andrew@virtecsolutions.com.au</a>
          </p>
          <p>
            Web: <a href="http://www.virtecsolutions.com.au/">www.virtecsolutions.com.au</a>
          </p>
        </div>
      </div>
    </div>
  );
};
